export enum USERS_DASHBOARD_STORAGE_KEYS {
  RolesPreference = "users-role-preference",
  StatusPreference = "users-status-preference",
  WebVersionPreference = "users-web-version-preference",
  CombiUserPreference = "users-combi-user-preference",
  MobileVersionsPreference = "users-mobile-version-preference",
  CameraVersionsPreference = "users-camera-preference",
  ActiveDateFromPreference = "users-active-date-from-preference",
  ActiveDateToPreference = "users-active-date-to-preference",
  DPOPreference = "users-dpo-preference",
  PageSizePreference = "users-page-size-preference"
}
